// Función interactiva para selector de peso en tarjetas de producto (global)
window.selectNeozooCardWeight = function(btn, e) {
    if (e) {
        e.preventDefault();
        e.stopPropagation();
    }
    if (!btn) return;

    const card = btn.closest('.neozoo-product-card');
    if (!card) return;

    const variationId = parseInt(btn.getAttribute('data-variation-id'), 10);
    let rawVars = card.getAttribute('data-variations') || (card.dataset ? card.dataset.variations : null);
    if (!rawVars) return;

    let variations = [];
    try {
        variations = typeof rawVars === 'string' ? JSON.parse(rawVars) : rawVars;
    } catch (err) {
        console.error('Error parseando variaciones de tarjeta:', err);
        return;
    }

    const selectedVar = variations.find(function(v) {
        return parseInt(v.variation_id, 10) === variationId;
    });
    if (!selectedVar) return;

    // Actualizar estado visual de los botones de peso
    const allBtns = card.querySelectorAll('.neozoo-card-weight-btn');
    allBtns.forEach(function(b) {
        b.classList.remove('active');
    });
    btn.classList.add('active');

    // Actualizar botón de comprar ahora (link directo a checkout con variation_id)
    const buyBtn = card.querySelector('.neozoo-card-buy-btn');
    if (buyBtn && selectedVar.add_to_cart) {
        buyBtn.setAttribute('href', selectedVar.add_to_cart);
    }

    // Actualizar precios (actual y tachado)
    const priceIntElem = card.querySelector('.price-int');
    const priceDecElem = card.querySelector('.price-dec');
    const oldPriceElem = card.querySelector('.card-old-price');
    const badgeOffElem = card.querySelector('.card-off');
    const badgeValElem = card.querySelector('.card-off-val');

    const saleNum = parseFloat(selectedVar.price) || 0;
    const regNum = parseFloat(selectedVar.regular_price) || 0;

    if (saleNum > 0) {
        const parts = saleNum.toFixed(2).split('.');
        const wholeFormatted = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        if (priceIntElem) priceIntElem.textContent = wholeFormatted;
        if (priceDecElem) priceDecElem.textContent = parts[1];
    }

    if (regNum > saleNum && saleNum > 0) {
        const regFormatted = '$' + regNum.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        if (oldPriceElem) {
            oldPriceElem.textContent = regFormatted;
            oldPriceElem.classList.remove('d-none');
        }
        if (selectedVar.percent > 0 && badgeOffElem && badgeValElem) {
            badgeValElem.textContent = selectedVar.percent + '% OFF';
            badgeOffElem.classList.remove('d-none');
        }
    } else {
        if (oldPriceElem) oldPriceElem.classList.add('d-none');
        if (badgeOffElem) badgeOffElem.classList.add('d-none');
    }

    // Actualizar imagen si la variación tiene una específica
    if (selectedVar.img_src) {
        const cardImg = card.querySelector('.card-img img');
        if (cardImg) {
            cardImg.setAttribute('src', selectedVar.img_src);
            cardImg.removeAttribute('srcset');
        }
    }
};

// Delegación de clic en document
document.addEventListener('click', function(e) {
    const btn = e.target.closest('.neozoo-card-weight-btn');
    if (btn) {
        window.selectNeozooCardWeight(btn, e);
    }
});

document.addEventListener('DOMContentLoaded', function () {
    // Inicializar Swiper para opiniones si existe
    var opinionesSwiper = document.querySelector('.opiniones-swiper');
    if (opinionesSwiper && typeof Swiper !== 'undefined') {
        new Swiper('.opiniones-swiper', {
            slidesPerView: 1,
            spaceBetween: 20,
            pagination: { el: '.swiper-pagination', clickable: true },
            loop: true,
            //effect: 'cube',
            speed: 600, // velocidad de transición más lenta (en ms)
            autoplay: {
                delay: 10000,
                disableOnInteraction: false,
            }
        });
    }

    // Inicializar Swiper para Hero Slider
    var heroSwiper = document.querySelector('.hero-swiper');
    if (heroSwiper && typeof Swiper !== 'undefined') {
        new Swiper('.hero-swiper', {
            slidesPerView: 1,
            spaceBetween: 0,
            effect: 'fade', // Efecto de fundido para el Hero
            fadeEffect: { crossFade: true },
            loop: true,
            pagination: {
                el: '.swiper-pagination',
                clickable: true
            },
            autoplay: {
                delay: 6000,
                disableOnInteraction: false,
            }
        });
    }

    // Inicializar Swiper para Noticias del Home solo en mobile XS (< 576px)
    var homeNewsSwiperElem = document.querySelector('.home-news-swiper');
    if (homeNewsSwiperElem && typeof Swiper !== 'undefined') {
        var homeNewsSwiper = null;

        function initHomeNewsSwiper() {
            var screenWidth = window.innerWidth;
            if (screenWidth < 576 && !homeNewsSwiper) {
                homeNewsSwiper = new Swiper('.home-news-swiper', {
                    slidesPerView: 1.12,
                    spaceBetween: 16,
                    grabCursor: true,
                    observer: true,
                    observeParents: true,
                    pagination: {
                        el: '.home-news-swiper .swiper-pagination',
                        clickable: true
                    }
                });
            } else if (screenWidth >= 576 && homeNewsSwiper) {
                homeNewsSwiper.destroy(true, true);
                homeNewsSwiper = null;
            }
        }

        initHomeNewsSwiper();
        window.addEventListener('resize', initHomeNewsSwiper);
    }

    // Funcionalidad para los filtros de productos
    // El filtrado solo se aplica al hacer clic en el botón Filtrar
    var productFilters = document.querySelector('.product-filters');
    if (productFilters) {
        const filterButton = document.getElementById('filtrar-btn');
        if (filterButton) {
            filterButton.addEventListener('click', function () {
                filterButton.textContent = 'Aplicando...';
                filterButton.classList.add('opacity-75');
            });
        }
    }

    // Auto-submit en el selector de ordenamiento (Ordenar por precio, novedad, etc.)
    const orderingSelect = document.querySelector('.woocommerce-ordering select.orderby');
    if (orderingSelect) {
        orderingSelect.addEventListener('change', function () {
            this.form.submit();
        });
    }
    // Convertir select de variaciones en botones y vincular datos de variación
    const formVariations = document.querySelector('form.variations_form');
    let productVariationsData = [];
    if (formVariations) {
        try {
            const rawData = formVariations.getAttribute('data-product_variations');
            if (rawData) {
                productVariationsData = JSON.parse(rawData);
            }
        } catch (e) {
            console.error('Error parsing data-product_variations', e);
        }
    }

    function formatPriceSup(price) {
        const numPrice = parseFloat(price);
        if (isNaN(numPrice)) return '';
        const formatted = numPrice.toFixed(2);
        const parts = formatted.split('.');
        const wholePart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        const decimalPart = parts[1];
        return `<span class="woocommerce-Price-amount amount"><bdi><sup>$</sup>${wholePart}<sup>,${decimalPart}</sup></bdi></span>`;
    }

    function updateMainPrice(variation) {
        const priceContainer = document.querySelector('#neozoo-single-price, .product-detail-page .price, .summary .price');
        if (!priceContainer || !variation) return;

        let html = '';
        if (variation.display_regular_price > variation.display_price) {
            const priceMain = formatPriceSup(variation.display_price);
            const priceOld = formatPriceSup(variation.display_regular_price);
            html = `<span class="price-main">${priceMain}</span><span class="card-old-price">${priceOld}</span>`;
        } else {
            const priceMain = formatPriceSup(variation.display_price);
            html = `<span class="price-main">${priceMain}</span>`;
        }
        priceContainer.innerHTML = html;
        if (!priceContainer.classList.contains('d-flex')) {
            priceContainer.classList.add('d-flex', 'align-items-center', 'gap-2');
        }
    }

    const variationButtons = document.querySelectorAll('.variation-buttons .variation-btn');
    variationButtons.forEach(btn => {
        btn.addEventListener('click', function () {
            const container = this.closest('.variation-buttons');
            const row = this.closest('td.value');
            const select = row ? row.querySelector('select') : null;
            const val = this.dataset.value;

            if (container) {
                container.querySelectorAll('.variation-btn').forEach(b => b.classList.remove('active'));
            }
            this.classList.add('active');

            if (select) {
                select.value = val;
                if (typeof jQuery !== 'undefined') {
                    jQuery(select).val(val).trigger('change');
                } else {
                    select.dispatchEvent(new Event('change', { bubbles: true }));
                }
            }

            // Actualización directa de precio y variation_id
            if (productVariationsData && productVariationsData.length) {
                const matchedVar = productVariationsData.find(v => {
                    const vAttr = v.attributes || {};
                    return Object.values(vAttr).includes(val) || (select && (vAttr['attribute_' + select.name] === val || vAttr[select.name] === val));
                });
                if (matchedVar) {
                    updateMainPrice(matchedVar);
                    const form = this.closest('form.variations_form');
                    if (form && matchedVar.variation_id) {
                        const varIdInputs = form.querySelectorAll('input[name="variation_id"], input.variation_id');
                        varIdInputs.forEach(inp => inp.value = matchedVar.variation_id);
                    }
                }
            }
        });
    });

    if (typeof jQuery !== 'undefined') {
        jQuery('.variations_form').on('found_variation', function (event, variation) {
            if (variation) {
                updateMainPrice(variation);
                var varIdInputs = this.querySelectorAll('input[name="variation_id"], input.variation_id');
                varIdInputs.forEach(function(input) {
                    input.value = variation.variation_id;
                });
            }
        });
    }
});


// Smart Sticky Mobile Menu
// Hide on scroll down, show on scroll up
var lastScrollTop = 0;
var fastMenu = document.querySelector('.fastmenu-xs');

if (fastMenu) {
    window.addEventListener("scroll", function () {
        var st = window.pageYOffset || document.documentElement.scrollTop;
        if (st > lastScrollTop && st > 100) {
            // Scroll Down > 100px
            fastMenu.classList.add('hide-menu');
        } else {
            // Scroll Up
            fastMenu.classList.remove('hide-menu');
        }
        lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
    }, false);
}

// Soporte y control robusto para el menú Offcanvas en móvil (XS)
document.addEventListener('click', function(e) {
    // Abrir o alternar menú con el botón hamburguesa
    var toggler = e.target.closest('[data-bs-toggle="offcanvas"], .navbar-toggler');
    if (toggler) {
        e.preventDefault();
        e.stopPropagation();
        var targetSelector = toggler.getAttribute('data-bs-target') || toggler.getAttribute('href') || '#navbarNavOffcanvas';
        var targetEl = document.querySelector(targetSelector);
        if (targetEl) {
            if (typeof understrap !== 'undefined' && understrap.Offcanvas) {
                var inst = understrap.Offcanvas.getOrCreateInstance(targetEl);
                if (inst) {
                    inst.toggle();
                    return;
                }
            } else if (typeof bootstrap !== 'undefined' && bootstrap.Offcanvas) {
                var instBs = bootstrap.Offcanvas.getOrCreateInstance(targetEl);
                if (instBs) {
                    instBs.toggle();
                    return;
                }
            }
            
            // Fallback nativo directo: alternar clases show y backdrop
            var isShown = targetEl.classList.contains('show');
            var existingBackdrop = document.querySelector('.offcanvas-backdrop');
            if (isShown) {
                targetEl.classList.remove('show', 'showing');
                targetEl.style.visibility = '';
                if (existingBackdrop) {
                    existingBackdrop.remove();
                }
            } else {
                targetEl.classList.add('show');
                targetEl.style.visibility = 'visible';
                if (!existingBackdrop) {
                    var backdrop = document.createElement('div');
                    backdrop.className = 'offcanvas-backdrop fade show';
                    document.body.appendChild(backdrop);
                    backdrop.addEventListener('click', function() {
                        targetEl.classList.remove('show', 'showing');
                        targetEl.style.visibility = '';
                        backdrop.remove();
                    });
                }
            }
        }
        return;
    }

    // Botón de cerrar del offcanvas
    var dismissBtn = e.target.closest('[data-bs-dismiss="offcanvas"]');
    if (dismissBtn) {
        e.preventDefault();
        var offcanvasEl = dismissBtn.closest('.offcanvas');
        if (offcanvasEl) {
            if (typeof understrap !== 'undefined' && understrap.Offcanvas) {
                var instClose = understrap.Offcanvas.getInstance(offcanvasEl);
                if (instClose) {
                    instClose.hide();
                    return;
                }
            } else if (typeof bootstrap !== 'undefined' && bootstrap.Offcanvas) {
                var instCloseBs = bootstrap.Offcanvas.getInstance(offcanvasEl);
                if (instCloseBs) {
                    instCloseBs.hide();
                    return;
                }
            }
            offcanvasEl.classList.remove('show', 'showing');
            offcanvasEl.style.visibility = '';
            var activeBackdrop = document.querySelector('.offcanvas-backdrop');
            if (activeBackdrop) {
                activeBackdrop.remove();
            }
        }
    }
});

// Manejador AJAX para eliminar un producto desde el resumen de pedido en el Checkout
(function($) {
    $(document).on('click', '.neozoo-checkout-remove-item', function(e) {
        e.preventDefault();
        var $btn = $(this);
        var cartItemKey = $btn.data('cart_item_key');
        if (!cartItemKey) return;

        var $orderReview = $('#order_review');
        if ($orderReview.length) {
            $orderReview.addClass('opacity-50 pointer-events-none');
        }

        $.ajax({
            type: 'POST',
            url: (typeof wc_checkout_params !== 'undefined' ? wc_checkout_params.ajax_url : '/wp-admin/admin-ajax.php'),
            data: {
                action: 'neozoo_checkout_remove_cart_item',
                cart_item_key: cartItemKey
            },
            success: function(res) {
                if (res && res.success) {
                    if (res.data && res.data.cart_empty) {
                        window.location.reload();
                    } else {
                        // Disparar evento nativo de WooCommerce para refrescar el checkout vía AJAX
                        $(document.body).trigger('update_checkout');
                    }
                } else {
                    if ($orderReview.length) {
                        $orderReview.removeClass('opacity-50 pointer-events-none');
                    }
                }
            },
            error: function() {
                if ($orderReview.length) {
                    $orderReview.removeClass('opacity-50 pointer-events-none');
                }
            }
        });
    });

    // Buscador interactivo desplegable en cabecera desktop
    $(document).on('click', '.header-neozoo__search-toggle', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var $form = $(this).siblings('.header-neozoo__search-form');
        $form.toggleClass('d-none');
        if (!$form.hasClass('d-none')) {
            $form.find('input[name="s"]').focus();
        }
    });

    // Cerrar el buscador al hacer clic fuera o presionar Esc
    $(document).on('click', function(e) {
        if (!$(e.target).closest('.header-neozoo__search-wrap').length) {
            $('.header-neozoo__search-form').addClass('d-none');
        }
    });

    $(document).on('keydown', function(e) {
        if (e.key === 'Escape') {
            $('.header-neozoo__search-form').addClass('d-none');
        }
    });
})(jQuery);

